import api from '../../../api/axios';
import { API_ENDPOINTS } from '../../../api/endpoints';
import type { VesselAlert, VesselChangeList, VesselChangeScope } from '../types/vesselChanges';
import { readVesselAlerts, readVesselChangeList } from './response';

/** My (or my team's) jobs whose dates differ from PTP, grouped by vessel call. */
export const fetchVesselChanges = async (scope: VesselChangeScope): Promise<VesselChangeList> => {
  const { data } = await api.get(API_ENDPOINTS.VESSEL_CHANGES.LIST, { params: { scope } });
  return readVesselChangeList(data);
};

/** My open vessel alerts and my team's escalated ones; each call re-checks the jobs. */
export const fetchVesselAlerts = async (): Promise<VesselAlert[]> => {
  const { data } = await api.get(API_ENDPOINTS.VESSEL_CHANGES.ALERTS);
  return readVesselAlerts(data);
};
